module.exports = new __parcel__URL__("../../checkmark.c1eb4c6f.svg").toString();